module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 for(var i= 0; i < totalRegions; i++) { ;
__p += '\n<div id="' +
((__t = ( _.uniqueId('carouselRegion') )) == null ? '' : __t) +
'"></div>\n';
 } ;


}
return __p
}